/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { GradingMachineProcessTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const gradingMachineProcessFetchListLoading = (state, { boolean }) => ({
  ...state,
  processIsLoading: boolean
});

export const gradingMachineProcessFetchListSuccess = (state, { process }) => ({
  ...state,
  process
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [GradingMachineProcessTypes.GRADING_MACHINE_PROCESS_FETCH_LIST_LOADING]: gradingMachineProcessFetchListLoading,
  [GradingMachineProcessTypes.GRADING_MACHINE_PROCESS_FETCH_LIST_SUCCESS]: gradingMachineProcessFetchListSuccess
});
